/**
 * This package's translations, registered at import.
 *
 * Its own namespace, not the integration contract's, for the same reason it is
 * its own package: the connector and its screen are removed together, and a
 * bundle that lived in the contract's namespace would leave dead keys behind.
 */

import { registerNamespace } from "@hardauto/core-i18n";

import en from "./locales/en.json";
import fr from "./locales/fr.json";

export const NAMESPACE = "connectorFiles";

registerNamespace(NAMESPACE, { en, fr });
